















export default {
    name: 'CoTextArea',
    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        rows: {
            type: Number,
            default: 3,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    data() {
        return {
            content: this.value,
        };
    },
    watch: {
        content(newVal) {
            this.$emit('input', newVal);
        },
        value(newVal) {
            this.content = newVal;
        },
    },
    created() {
        this.content = this.value;
    },
    mounted() {
        this.$nextTick(() => {
            this.content = this.value;
        });
    },
    methods: {
        handleInput(e) {
            this.content = e.target.value;

            this.$emit('input', this.content);
        },
    },
};
